module.exports = __webpack_public_path__ + "static/media/addData.24468e69.svg";